<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Lead from '$lib/PageSections/Forms/Lead/Lead.svelte';
	import GetIndowSteps from '$lib/PageSections/GetIndowSteps/GetIndowSteps.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';
	import TrustedChoice from '$lib/PageSections/TrustedChoice/TrustedChoice.svelte';
</script>

<Section class="**:text-left">
	<h2>Connect With A Fit Specialist</h2>
	<p>
		Fill out the form below and tell us about your windows. We'll answer any
		questions you have, provide you with an estimate at our best pricing, and
		help you determine if Indow is the right fit for the issues you're facing.
	</p>
	<Lead buttonText="Create Comfort Now" textString={false} requirePostalCode />
</Section>

<Section backgroundColor="blue">
	<GetIndowSteps />
</Section>

<Reviews />
<TrustedChoice />
